import type { MediaGroup } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";
import type { MediaOwnerType } from "./fetch-media-asset";

export type MediaAssetQueryScope = "auth" | "public";

export function mediaAssetQueryScope(requireAuth: boolean): MediaAssetQueryScope {
  return requireAuth ? "auth" : "public";
}

export function getMediaAssetQueryKey(
  tenantId: number,
  ownerType: MediaOwnerType,
  ownerId: number,
  mediaGroup: MediaGroup,
  scope: MediaAssetQueryScope,
) {
  return [QueryKeys.MediaAsset, scope, tenantId, ownerType, ownerId, mediaGroup] as const;
}

export async function invalidateMediaAssetQueries(
  queryClient: import("@tanstack/react-query").QueryClient,
  tenantId: number,
  ownerType: MediaOwnerType,
  ownerId: number,
  mediaGroup: MediaGroup,
) {
  await Promise.all(
    (["auth", "public"] as const).map((scope) =>
      queryClient.invalidateQueries({
        queryKey: getMediaAssetQueryKey(
          tenantId,
          ownerType,
          ownerId,
          mediaGroup,
          scope,
        ),
      }),
    ),
  );
}
